module.exports = __webpack_public_path__ + "static/images/92a119e64d41fc9f4c4930556decbdf0.png";